// MyOrders component goes in this file..
import React from 'react';

import '../../../assets/styles/cart-styles/MyOrders.scss';
// OR
// import '../../../assets/styles/cart-styles/MyOrders.css';

export default function MyOrders() {
    return (
        <div>
            <h1>MyOrders</h1>
        </div>
    )
}
